class MealOverviewModalController {
  constructor() {
    this.currentHandle = null;
    this.isInit = true;
    this.displayButtons = false;
    this.mealData = null;

    // Swipe gallery state
    this.currentImageIndex = 0;
    this.images = [];
    this.touchStartX = 0;
    this.touchEndX = 0;

    this.containerEl = document.querySelector('#meal-overview-modal-container');
    this.closeBtn = document.querySelector('#meal-overview-modal-close-btn');
    this.loaderEl = document.querySelector('#meal-overview-modal-loader');

    this.reviewTextEl = document.querySelector('#meal-overview-modal-rating-text');
    this.ratingsStarContainer = document.querySelector('#meal-overview-modal-rating-stars');

    this.galleryImage = document.querySelector('#meal-overview-primary-image');
    this.galleryThumbs = document.querySelector('#meal-overview-gallery-thumbs');
    this.titleEl = document.querySelector('#meal-overview-modal-product-title');
    this.descriptionEl = document.querySelector('#meal-overview-modal-description');
    this.drawerTitleElements = document.querySelectorAll('.meal-overview-modal-info-drawer-title');

    this.mealOverviewNutrientCarbsDesktopEl = document.querySelector('#meal-overview-modal-nutrient-desktop-carbs');
    this.mealOverviewNutrientFettDesktopEl = document.querySelector('#meal-overview-modal-nutrient-desktop-fett');
    this.mealOverviewNutrientProteinDesktopEl = document.querySelector('#meal-overview-modal-nutrient-desktop-protein');
    this.mealOverviewNutrientKcalDesktopEl = document.querySelector('#meal-overview-modal-nutrient-desktop-kcal');

    this.mealOverviewNutrientCarbsMobileEl = document.querySelector('#meal-overview-modal-nutrient-mobile-carbs');
    this.mealOverviewNutrientFettMobileEl = document.querySelector('#meal-overview-modal-nutrient-mobile-fett');
    this.mealOverviewNutrientProteinMobileEl = document.querySelector('#meal-overview-modal-nutrient-mobile-protein');
    this.mealOverviewNutrientKcalMobileEl = document.querySelector('#meal-overview-modal-nutrient-mobile-kcal');

    this.zutatenDrawer = document.querySelector('#meal-overview-modal-info-drawer-zutaten');
    this.zubereitungDrawer = document.querySelector('#meal-overview-modal-info-drawer-zubereitung');

    this.mealItemElements = document.querySelectorAll('.box-ingredient-meal-item');
  }

  async open(e) {
    const { handle, mealNutrients, mealInfoDrawerData, rating, reviewCount } = e.target.closest('.box-ingredient-meal-item').dataset;

    // Clear previous content to prevent flickering
    this.galleryImage.style.opacity = '0';
    this.galleryImage.src = '';
    while (this.galleryThumbs.firstChild) {
      this.galleryThumbs.removeChild(this.galleryThumbs.firstChild);
    }
    this.titleEl.textContent = '';
    this.descriptionEl.textContent = '';
    this.currentImageIndex = 0;
    this.images = [];

    this.reviewTextEl.textContent = `${reviewCount} Bewertungen`;
    while (this.ratingsStarContainer.firstChild) {
      this.ratingsStarContainer.removeChild(this.ratingsStarContainer.firstChild);
    }

    const ratingNum = parseFloat(rating) || 0;
    for (let i = 0; i < 5; i++) {
      const starWrapper = document.createElement('span');
      starWrapper.className = 'star-wrapper';

      // Calculate fill percentage for this star
      const starFill = ratingNum - i;
      let fillPercent;
      if (starFill >= 1) {
        fillPercent = 100;
      } else if (starFill <= 0) {
        fillPercent = 0;
      } else {
        fillPercent = Math.round(starFill * 100);
      }

      starWrapper.style.setProperty('--fill-percent', `${fillPercent}%`);

      const starEmpty = document.createElement('span');
      starEmpty.className = 'star-empty';
      starEmpty.textContent = '★';

      const starFilled = document.createElement('span');
      starFilled.className = 'star-filled';
      starFilled.textContent = '★';

      starWrapper.appendChild(starEmpty);
      starWrapper.appendChild(starFilled);
      this.ratingsStarContainer.appendChild(starWrapper);
    }

    if (this.displayButtons) {
      this.mealData = document.querySelector(`.meal-list-item__increase-quantity-button[data-handle="${handle}"]`).dataset;
      this.mealData.mealId = Number(this.mealData.mealId);
      this.mealData.quantity = Number(this.mealData.quantity);

      const buttons = document.querySelectorAll('.meal-overview-modal-add-to-cart-button');

      for (let i = 0; i < buttons.length; i++) {
        const button = buttons[i];

        button.addEventListener('click', () => {
          this.close();

          window.buildABox.addMealToBox({
            quantity: Number(this.mealData.quantity),
            title: this.mealData.title,
            mealId: Number(this.mealData.mealId),
            imageUrl: this.mealData.imageUrl
          });

          button.replaceWith(button.cloneNode(true));
        });
      }
    }

    $('html').addClass('disabled-scroll');

    window.addEventListener("wheel", this.preventScroll.bind(this));
    window.addEventListener("touchmove", this.preventScroll.bind(this));

    this.showLoader();
    this.containerEl.classList.add('active');

    const res = await fetch(`/products/${handle}.js`);
    const mealData = await res.json();

    let parsedNutrients;
    let parsedDrawerData;

    if (mealNutrients) {
      parsedNutrients = JSON.parse(mealNutrients);
    }

    if (mealInfoDrawerData) {
      parsedDrawerData = JSON.parse(mealInfoDrawerData);
    }

    this.populateModal({
      ...mealData,
      mealNutrients: parsedNutrients,
      drawerData: parsedDrawerData
    })

    this.hideLoader();
  }

  handleAddToBox() {

  }

  populateModal(mealData) {
    const { images, title, description, mealNutrients, drawerData } = mealData;

    // Store images for swipe navigation
    this.images = images;
    this.currentImageIndex = 0;

    while (this.galleryThumbs.firstChild) {
      this.galleryThumbs.removeChild(this.galleryThumbs.firstChild);
    }

    const defaultDrawerText = 'Kommt bald';

    this.zutatenDrawer.textContent = drawerData?.Zutaten || defaultDrawerText;
    this.zubereitungDrawer.textContent = drawerData?.Zubereitung || defaultDrawerText;

    for (let i = 0; i < this.drawerTitleElements.length; i++) {
      const drawerTitleEl = this.drawerTitleElements[i];

      if (this.isInit) {
        drawerTitleEl.addEventListener('click', () => {
          drawerTitleEl.parentElement.querySelector('.meal-overview-modal-info-drawer-content').classList.toggle('active');
        });
      }
    }

    images.forEach((image, i) => {
      const li = document.createElement('li');
      li.dataset.src = image;
      li.dataset.index = i;

      if (i === 0) li.classList.add('active');

      this.galleryThumbs.appendChild(li);

      li.addEventListener('click', () => {
        this.goToImage(i);
      })
    });

    this.titleEl.textContent = title;

    // Load image and fade in when ready
    this.galleryImage.onload = () => {
      this.galleryImage.style.opacity = '1';
    };
    this.galleryImage.src = images[0];

    // Set description (this may contain HTML from Shopify)
    this.descriptionEl.textContent = '';
    const descWrapper = document.createElement('div');
    descWrapper.textContent = description.replace(/<[^>]*>/g, ''); // Strip HTML tags for safety
    this.descriptionEl.appendChild(descWrapper);

    if (mealNutrients) {
      this.mealOverviewNutrientKcalDesktopEl.textContent = mealNutrients.KCAL;
      this.mealOverviewNutrientCarbsDesktopEl.textContent = mealNutrients.CARBS;
      this.mealOverviewNutrientProteinDesktopEl.textContent = mealNutrients.PROTEIN;
      this.mealOverviewNutrientFettDesktopEl.textContent = mealNutrients.FETT;

      this.mealOverviewNutrientKcalMobileEl.textContent = mealNutrients.KCAL;
      this.mealOverviewNutrientCarbsMobileEl.textContent = mealNutrients.CARBS;
      this.mealOverviewNutrientProteinMobileEl.textContent = mealNutrients.PROTEIN;
      this.mealOverviewNutrientFettMobileEl.textContent = mealNutrients.FETT;
    }

    this.isInit = false;
  }

  // Swipe navigation methods
  goToImage(index) {
    if (index < 0 || index >= this.images.length) return;

    this.currentImageIndex = index;
    this.galleryImage.src = this.images[index];

    // Update thumb indicators
    const allThumbs = this.galleryThumbs.querySelectorAll('li');
    for (let i = 0; i < allThumbs.length; i++) {
      allThumbs[i].classList.remove('active');
    }
    if (allThumbs[index]) {
      allThumbs[index].classList.add('active');
    }
  }

  nextImage() {
    if (this.currentImageIndex < this.images.length - 1) {
      this.goToImage(this.currentImageIndex + 1);
    }
  }

  prevImage() {
    if (this.currentImageIndex > 0) {
      this.goToImage(this.currentImageIndex - 1);
    }
  }

  handleTouchStart(e) {
    this.touchStartX = e.changedTouches[0].screenX;
  }

  handleTouchEnd(e) {
    this.touchEndX = e.changedTouches[0].screenX;
    this.handleSwipe();
  }

  handleSwipe() {
    const swipeThreshold = 50;
    const diff = this.touchStartX - this.touchEndX;

    if (Math.abs(diff) < swipeThreshold) return;

    if (diff > 0) {
      // Swiped left - next image
      this.nextImage();
    } else {
      // Swiped right - previous image
      this.prevImage();
    }
  }

  showLoader() {
    this.loaderEl.classList.add('active');
  }

  hideLoader() {
    this.loaderEl.classList.remove('active');
  }

  close() {
    $('html').removeClass('disabled-scroll');

    window.removeEventListener("wheel", this.preventScroll.bind(this));
    window.removeEventListener("touchmove", this.preventScroll.bind(this));

    this.containerEl.classList.remove('active');

    for (let i = 0; i < this.drawerTitleElements.length; i++) {
      const drawerTitleEl = this.drawerTitleElements[i];
      drawerTitleEl.parentElement.querySelector('.meal-overview-modal-info-drawer-content').classList.remove('active');
    }
  }

  init() {
    if (this.containerEl.dataset.displayButtons) {
      const displayButtons = JSON.parse(this.containerEl.dataset.displayButtons);

      this.displayButtons = displayButtons === true;
    }

    this.closeBtn.addEventListener('click', () => {
      this.close();
    });

    // Add swipe support for gallery image
    this.galleryImage.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
    this.galleryImage.addEventListener('touchend', this.handleTouchEnd.bind(this), { passive: true });

    for (let i = 0; i < this.mealItemElements.length; i++) {
      const mealItemEl = this.mealItemElements[i];

      mealItemEl.addEventListener('click', this.open.bind(this));
    }
  }

  preventScroll(e) {
    if (!this.isDescendant($('.custom-drawer-container'), e.target)) {
      e.preventDefault();
      return false;
    }

    let modalTop = modalEl.scrollTop === 0;
    let modalBottom = modalEl.scrollTop === (modalEl.scrollHeight - modalEl.clientHeight);

    if (modalTop && e.deltaY < 0) {
      e.preventDefault();
    } else if (modalBottom && e.deltaY > 0) {
      e.preventDefault();
    }
  }

  isDescendant(parent, child) {
    var node = child.parentNode;
    while (node != null) {
      if (node == parent) {
        return true;
      }
      node = node.parentNode;
    }
    return false;
  }

}